module.exports = __webpack_public_path__ + "img/cloud-fog-sun.5e72be36.svg";